<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.addresses.title')}}
		</div>
		<div class="toolArea">
			<div>{{$t('mypages.addresses.createdPrefix')}}<span>{{totalcount}}</span>{{$t('mypages.addresses.createdSuffix')}}</div>
			<div class="addBtn" @click="showAddress(0)">{{$t('mypages.addresses.add')}}</div>
		</div>
		<table>
			<thead>
				<th><div class="tdInner">{{$t('mypages.addresses.th_recipient')}}</div></th>
				<th><div class="tdInner">{{$t('mypages.addresses.th_phone')}}</div></th>
				<th><div class="tdInner tdLeft">{{$t('mypages.addresses.th_address')}}</div></th>
				<th><div class="tdInner">{{$t('mypages.addresses.th_action')}}</div></th>
			</thead>
			<tbody>
				<tr v-for="(item, index) in receiveInfo" :key="item.id">
					<td><div class="tdInner">{{item.receive_man}}</div></td>
					<td><div class="tdInner">{{item.receive_mobile}}</div></td>
					<td><div class="tdInner tdLeft">{{item.receive_address}}<div class="label" v-if="item.is_default">{{$t('mypages.addresses.default_label')}}</div></div></td>
					<td><div class="tdInner">
						<div class="edit"  @click="showAddress(item.id)">{{$t('mypages.addresses.edit')}}</div>
						<div class="delete" @click="DeleteContact(item.id)">{{$t('mypages.addresses.delete')}}</div>
					</div></td>
				</tr>
				
			</tbody>
		</table>
		<PopupAddress :visible="addressVisible" :selectId="editId" @close="closeAddress"></PopupAddress>
	</div>
</template>

<script>
	import PopupAddress from '../../components/addressPopup.vue'
	export default {
		components:{
			PopupAddress
		},
		data() {
			return {
				receiveInfo: [],
				pageIndex:1,
				totalcount:1,
				addressVisible: false,
				editId:0,

			}
		},
		created() {
			this.getReceiveInfo();
		},
		methods: {
			getReceiveInfo() {
				this.receiveInfo=[];
				this.$scUtil.axiosPut(this, 'ReceiveApi/GetReceiveList', {
					pageIndex:this.pageIndex,
					pageSize:10,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						this.receiveInfo = res.data;
						this.totalcount=res.totalcount;
					}
	
				});
			},
			showAddress(id){
				this.addressVisible = true;
				this.editId=id;
			},
			closeAddress(){
				this.addressVisible = false;
				this.getReceiveInfo();
			},
			DeleteContact(id){
					this.$confirm(this.$t('mypages.addresses.confirm_delete'), this.$t('mypages.addresses.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('mypages.addresses.confirm_confirm'),
					        cancelButtonText: this.$t('mypages.addresses.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try 
						 {
				         	this.$scUtil.axiosPost(this, 'ReceiveApi/Delete', {
				         		id: id,
				         	}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getReceiveInfo();
				         			console.log("为什么删除了不刷新数据");
									console.log(JSON.stringify(this.shopCartList));
				         			return;
				         		}
				         
				         	});
				         } catch (error) {
				         	console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						console.log(action)
				        if (action == 'cancel'||cation=='close') {
							console.log("执行了吗")
				          this.getReceiveInfo();
				        }
				})
			}
			
		}
	}
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	.toolArea{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 53px;
		background-color: #fff;
		padding: 0 20px;
		box-sizing: border-box;
		font-size: 13px;
		color: #333333;
		font-weight: bolder;
	}
	
	.toolArea span{
		color: #0380fe;
	}
	
	.addBtn{
		width: 76px;
		height: 24px;
		background-color: #0380fe;
		border-radius: 5px;
		text-align: center;
		line-height: 24px;
		color: #fff;
		font-size: 12px;
	}

	table{
		margin-top: 12px;
		background-color: #fff;
		width: 100%;
	}
	
	table thead th{
		height: 60px;
		border-bottom: 3px solid #ebecee;
		font-size: 13px;
		color: #333333;
		text-align: center;
	}

	table tbody td .tdInner{
		min-height: 69px;
		border-bottom: 1px solid #e2e2e2;
		font-size: 13px;
		color: #000000;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	table thead th .tdLeft{
		text-align:left;
	}
	
	table tbody td .tdLeft{
		justify-content: flex-start;
	}
	
	table{
		border-collapse: collapse;
	}
	
	.label{
		width: 34px;
		height: 15px;
		background-color: #0380fe;
		color: #fff;
		font-size: 10px;
		text-align: center;
		line-height: 15px;
		border-radius: 4px;
		margin-left: 10px;
	}
	
	.edit{
		font-size: 13px;
		color: #0380fe;
		cursor: pointer;
	}
	
	.delete{
		font-size: 13px;
		color: #666666;
		margin-left: 20px;
		cursor: pointer;
	}
	
	table thead th:nth-child(1),
	table tbody tr td:nth-child(1){
		padding-left: 20px;
		box-sizing: border-box;
	}
	
	
	table thead th:nth-last-child(1),
	table tbody tr td:nth-last-child(1){
		padding-right: 20px;
		box-sizing: border-box;
	}
</style>